import Client from './Client';

export const UsersApi = {
    list: async (page, filter = '', sortBy = 'created_at', sortDir = 'desc', subscribersOnly = false) => {
        let url = `/v1/users?page=${page}&filter=${filter}&sort_by=${sortBy}&sort_dir=${sortDir}`;
        if (subscribersOnly) url += '&subscribers_only=1';
        return await Client.get(url);
    },
    validity: async (id, values) => {
        return await Client.post(`/v1/users/${id}/validity`, values);
    },
    api: async (id, values) => {
        return await Client.post(`/v1/users/${id}/api`, values);
    },
    toggleModule: async (id, module_id) => {
        return await Client.post(`/v1/users/${id}/module/${module_id}`, {});
    },
    delete: async (id) => {
        return await Client.destroy(`/v1/users/${id}`);
    }
};

export default UsersApi;
